import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Reservation from "@/pages/Reservation";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            setTimeout(() => {
                document
                    .querySelector(hash)
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 60);
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen bg-noir text-white">
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/reservation" element={<Reservation />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
